// Figma frame 03 link expired (33:937). US-082.
//
// Auth-backend's GET /auth/consume answers 410 with title
// `magic_link_expired` or `magic_link_consumed` (backend/api/routes/auth.py)
// — two distinct reasons routed to this one screen. `reason` is this
// screen's own contract for how it learns which: an optional `?reason=`
// search param, defaulting to "expired" when absent (i.e. reached directly
// by URL, or from a caller that hasn't been told the split). See this
// agent's progress notes for the handoff to `screens-auth-b`, who owns the
// /auth/callback route that will set it after consuming.

import { AuthShell } from "./AuthShell";
import { EmailRequestForm } from "./EmailRequestForm";
import { Icon } from "../../ui";

export type LinkExpiredReason = "expired" | "consumed";

const COPY: Record<LinkExpiredReason, { banner: string; heading: string }> = {
  expired: {
    banner: "That link has expired. They're good for 15 minutes.",
    heading: "Link expired",
  },
  consumed: {
    banner: "That link has already been used. Sign-in links are single-use.",
    heading: "Link already used",
  },
};

export type LinkExpiredScreenProps = {
  reason?: LinkExpiredReason;
  onSent: (email: string) => void;
};

export function LinkExpiredScreen({
  reason = "expired",
  onSent,
}: LinkExpiredScreenProps) {
  const copy = COPY[reason];
  return (
    <AuthShell>
      <div className="maisight-signin-banner" role="alert">
        <span className="maisight-signin-banner-icon" aria-hidden="true">
          <Icon name="alert-triangle" size={18} />
        </span>
        <p className="maisight-signin-banner-text type-bodyS">{copy.banner}</p>
      </div>
      <h1 className="maisight-signin-heading type-h2">{copy.heading}</h1>
      <p className="maisight-signin-body type-bodyS">
        Sign-in links are single-use and short-lived. Request a fresh one and
        it&rsquo;ll arrive in a few seconds.
      </p>
      <EmailRequestForm
        submitLabel="Send a new link"
        pendingLabel="Sending…"
        help="We will send the new link here."
        onSuccess={onSent}
      />
    </AuthShell>
  );
}
